import React,{useState,useCallback,useEffect} from 'react';
import {FaDownload,FaCalendar,FaCalendarAlt,FaCalendarDay,FaSearch} from 'react-icons/fa';
import DatePicker from "react-datepicker";
import {Spinner,Dropdown} from 'react-bootstrap';
import {RAjax} from '@putil-view/request.r-ajax';
import {SysPath} from 'SysContext';
import PropTypes from 'prop-types';
const DateInput = ({handleChange}) => {
  const onChange = useCallback((date)=>{
    handleChange(date)
  },[handleChange])

  return (
    <DatePicker placeholderText="Choose a date" className="text-center"  onChange={onChange} />
  );
};
DateInput.propTypes = {
  handleChange: PropTypes.func,
};

const MonthInput = ({handleChange}) => {
  const onChange = useCallback((date)=>{
    handleChange(date)
  },[handleChange])

  return (
    <DatePicker placeholderText="Choose a month" className="text-center" onChange={onChange} />
  );
};
MonthInput.propTypes = {
  handleChange: PropTypes.func,
};
export const QrTableCSV = ({keyword,dataType}) =>{

  const [state, setState] = useState({stage:"REQUEST_USER_INPUT",csv:'',csvKeyword:'', datas:null,fileName:null});
  const downloadAnchorRef = React.useRef();
  const handleDate = (type) =>{
    var today = new Date();
    var csvKeyword;
    switch(type){
      default:
      case "today":
        csvKeyword = (today.getMonth()+1).toString() + '/' + today.getDate() + '/' + today.getFullYear();
      break;
      case "month":
        csvKeyword = (today.getMonth()+1).toString() + '/$day$/' + today.getFullYear();
        break;
      case "year":
        csvKeyword = '$month$/$day$/' + today.getFullYear();
      break;
      case "searched":
        csvKeyword = keyword;
      break;
    }
    setState(prevState=>{return{...{prevState},...{stage:"REQUEST_DATA_FILE",csvKeyword:csvKeyword,fileName: 'E-Locker '+ dataType +' record '+csvKeyword.replace('$month$/$day$/','').replace('/$day$/','-').replaceAll('/','-') +'.csv'}}})
  };
  const handleCustomDate = (date) =>{
    const csvKeyword = (date.getMonth()+1).toString() + '/' + date.getDate() + '/' + date.getFullYear();
    setState(prevState=>{return{...{prevState},...{stage:"REQUEST_DATA_FILE",csvKeyword:csvKeyword,fileName: 'E-Locker '+ dataType +' record '+csvKeyword +'.csv'}}})
  };
  const handleCustomMonth = (date) =>{
    const csvKeyword = (date.getMonth()+1).toString() + '/$day$/' + date.getFullYear();
    setState(prevState=>{return{...{prevState},...{stage:"REQUEST_DATA_FILE",csvKeyword:csvKeyword,fileName: 'E-Locker '+ dataType +' record '+csvKeyword +'.csv'}}})
  };

  useEffect(()=>{
    if(state.stage === "DOWNLOAD_CSV_FILE"){
      downloadAnchorRef.current.download = state.fileName;
      downloadAnchorRef.current.click();
      setState({stage:"REQUEST_USER_INPUT",csv:'',csvKeyword:'', datas:null,fileName:null});
    }
  },[state.stage,dataType,state.fileName])
  return(
    <>
    <a ref={downloadAnchorRef} style={{display:'none'}} href={'data:text/csv;charset=utf-8,' + encodeURI(state.csv)} rel="noopener noreferrer" target="_blank">Download</a>
        <div className="input-group mb-3" style={{width:'auto'}}>
          <Dropdown  className="input-group-prepend" style={state.stage === "REQUEST_USER_INPUT"?{}:{display:'none'}}>
            <Dropdown.Toggle className="input-group-text btn-success bg-custom-green rounded-0" style={{}} id="dropdown-basic2">
              <FaDownload className="h6 mb-0"/>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={()=>handleDate("today")}>
                <><FaCalendarDay className="h5 mb-0"/><small className="pl-2">Today</small></>
              </Dropdown.Item>
              <Dropdown.Item onClick={()=>handleDate("month")}>
                <><FaCalendarAlt className="h5 mb-0"/><small className="pl-2">This month</small></>
              </Dropdown.Item>
              <Dropdown.Item onClick={()=>handleDate("year")}>
                <><FaCalendar className="h5 mb-0"/><small className="pl-2">This year</small></>
              </Dropdown.Item>
              <Dropdown.Item onClick={()=>handleDate("searched")}>
                <><FaSearch className="h5 mb-0"/><small className="pl-2">Searched</small></>
              </Dropdown.Item>
              <div className="mt-1">
                <small><DateInput handleChange={handleCustomDate}/></small>
              </div>
              <div className="mt-1">
                <small><MonthInput handleChange={handleCustomMonth}/></small>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>


    {state.stage === "REQUEST_DATA_FILE" &&
      (()=>{
        let url = null;
        const urls ={
            "match": SysPath.getByKeywordUrl,
            "matches": SysPath.getMatchRecordsByKeywordUrl,
            "clear": SysPath.getClearRecordsByKeywordUrl,
            "unclear": SysPath.getUnclearRecordsByKeywordUrl,
            "labels": SysPath.getLabelUrl,
            "prints": SysPath.getPrintRecordsByKeywordUrl,
            "scans": SysPath.getByKeywordUrl,
            "unlocks": SysPath.getUnlockRecordsUrl,
            "mismatch": SysPath.getMismatchRecordsUrl
        }
        url = urls[dataType] + "?keyword="+state.csvKeyword+"&limit=2147483647&offset=0&sort=" + encodeURI(JSON.stringify({"Create Time": "descending"}));
        return(
          <>
          <Spinner animation="border" role="status" className="mt-1"/>
          <RAjax requestResponse={true}
              requestOptions={{
                method: 'get',
                withCredentials: true,
                url: url
              }}
            handleResponse={(response)=>{

              const getDateTimeString = (value)=>{
                return new Date(value).toLocaleString('en-HK').split(', ');
              }
              const getRawValue = (value)=>{
                return value;
              }
              const config ={
                'Text':{
                  header: 'ID',
                  valueFunc: getRawValue
                },
                'Create Time':{
                  header: 'Date,Time',
                  valueFunc: getDateTimeString
                },
                'Creator':{
                  header: 'Creator',
                  valueFunc: getRawValue
                },
                'Type':{
                  header: 'Type',
                  valueFunc: getRawValue
                },
                'Cut Padlock':{
                  header: 'Cut Padlock',
                  valueFunc: getRawValue
                },
                'Items Found':{
                  header: 'Items Found',
                  valueFunc: getRawValue
                },
                'Reserved':{
                  header: 'Reserved',
                  valueFunc: getRawValue
                },
                'Location':{
                  header: 'Location',
                  valueFunc: getRawValue
                },
                'Disposed':{
                  header: 'Disposed',
                  valueFunc: getRawValue
                }
              };
              if(response &&response.data &&response.data.datas){
                var csv = response.data.datas.map(function(elem,index){
                  var csvline = index === 0
                  ?
                    Object.keys(elem).filter((key)=>{
                      return config[key];
                    }).map((key,index)=>{
                        return config[key].header;
                    }).join(',') +'\n'
                  : '';
                  csvline += Object.entries(elem).filter(([key,value])=>{
                    return config[key];
                  }).map(([key,value])=>{
                    return config[key].valueFunc(value);
                  }).join(',');
                  return csvline;
                }).join('\n');
                setState(prevState=>{return{...prevState,...{stage:"DOWNLOAD_CSV_FILE",csv:csv, datas:response.data.datas}}})
              }
            }}
          />
          </>
      )})()
    }
    </>
  )
}
QrTableCSV.propTypes = {
  keyword:PropTypes.string,
  dataType: PropTypes.string
};
